import { CheckCircleIcon } from "@heroicons/react/24/solid";

import useVehicleWorkflow from "../../data/useVehicleWorkflow";
import classNames from "../../utils/classNames";
import Card from "../shared/Card/Card";
import LoadingWheel from "../shared/LoadingWheel";

export default function VehicleWorkflowPanel({ vehicleId }: { vehicleId: string }) {
  const vehicleWorkflow = useVehicleWorkflow(vehicleId);
  const workflow = vehicleWorkflow.data?.data ?? [];

  return (
    <Card title="Workflow" bodyClassName="p-4 sm:p-6">
      {vehicleWorkflow.isLoading ? (
        <div className="flex justify-center py-6">
          <LoadingWheel />
        </div>
      ) : workflow.length === 0 ? (
        <p className="text-sm text-gray-500">No workflow steps available for this vehicle.</p>
      ) : (
        <div className="overflow-x-auto pb-1">
          <ol className="flex w-full min-w-max items-start gap-0">
            {workflow.map((step, index) => (
              <li
                key={step.label}
                className={classNames(
                  "flex items-start",
                  index < workflow.length - 1 && "flex-1"
                )}
              >
                <div className="flex flex-col items-center w-20 sm:w-24 flex-shrink-0 px-1 text-center">
                  <div
                    className={classNames(
                      "flex h-9 w-9 items-center justify-center rounded-full border-2",
                      step.complete
                        ? "border-green-600 bg-green-600 text-white"
                        : "border-gray-300 bg-white text-gray-400"
                    )}
                  >
                    {step.complete ? (
                      <CheckCircleIcon className="h-5 w-5" />
                    ) : (
                      <span className="h-2.5 w-2.5 rounded-full bg-gray-300" />
                    )}
                  </div>
                  <span
                    className={classNames(
                      "mt-2 text-xs leading-tight",
                      step.complete ? "text-gray-400 line-through" : "text-gray-800 font-medium"
                    )}
                  >
                    {step.label}
                  </span>
                  <span
                    className={classNames(
                      "mt-1 text-[10px] font-semibold uppercase tracking-wide",
                      step.complete ? "text-green-600" : "text-amber-600"
                    )}
                  >
                    {step.complete ? "Complete" : "Outstanding"}
                  </span>
                </div>
                {index < workflow.length - 1 && (
                  <div
                    className={classNames(
                      "mt-4 h-0.5 min-w-8 flex-1",
                      step.complete ? "bg-green-400" : "bg-gray-200"
                    )}
                  />
                )}
              </li>
            ))}
          </ol>
        </div>
      )}
    </Card>
  );
}
